import React from 'react';
import PropTypes from 'prop-types';
import { ModalStyled } from './styled';
import { AlertIcon, CancelButton, SubmitButton } from '../../atoms';

const ModalSticky = ({ show, onModalCancel, mode, onModalDoAction, title, body, actionLabel, cancelLabel, disabledSubmit }) => {
  return (
    <ModalStyled show={show}>
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <div className="modal-body">
          {mode === 'delete' && <AlertIcon className="modal-icon" />}
          {body instanceof String ? <p className="modal-text">{body}</p> : body}
          <hr />
          <div className="modal-buttons-row">
            <CancelButton onClick={onModalCancel} label={cancelLabel} />
            <SubmitButton disabled={disabledSubmit} onClick={onModalDoAction} label={actionLabel} />
          </div>
        </div>
      </div>
    </ModalStyled>
  );
};

ModalSticky.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actionLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onModalDoAction: PropTypes.func,
  onModalCancel: PropTypes.func,
  mode: PropTypes.string,
  disabledSubmit: PropTypes.bool,
};

export default ModalSticky;
